import { render, staticRenderFns } from "./UpgradeDialogDependent.vue?vue&type=template&id=f183b86a"
import script from "./UpgradeDialogDependent.vue?vue&type=script&lang=js"
export * from "./UpgradeDialogDependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports